<wl-timer
  [dateToCountDownTo]="content.dateToCountDownTo"
  [labels]="content.timerLabels"
/>
